import "./SideBar.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "./logo.png";
import hat from "./hat.png";
import boxes from "./boxes.png";
import notepad from "./notepad.png";
import assessment from "./assignment.png";
import user from "./user.png";
import people from "./people.png";
import logOut from "./logout.png";
import dash from "./dash.svg";
import more from "./more.svg";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    ButtonGroup,
    ClickAwayListener,
    Grow,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Stack,
    Typography,
} from "@mui/material";
import { useParentalInfoCheck } from "../../../context/ParentalInfoCheck";

const SideBar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedItem, setSelectedItem] = useState("");
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const { isParentInfoPresent, snackbarOpen, setSnackbarOpen } =
        useParentalInfoCheck();
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    useEffect(() => {
        const currentPath = location.pathname.replace("/", "");
        setSelectedItem(currentPath);
    }, [location.pathname]);
    const onClick = (rt) => {
        setSelectedItem(rt);
        localStorage.setItem("selectedMenuItem", rt);
        navigate(`/${rt}`, { state: {} });
    };
    function logout() {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
    }

    return (
        <div className="sideBarComponent">
            <div>
                <div className="sideBarComponent-logo">
                    <img src={logo} />
                </div>
                <div className="sideBarComponent-partition"></div>
                <div className="sideBarComponent-links">
                    <div
                        className="Link"
                        onClick={() => onClick("studentDashboard")}
                    >
                        <img src={dash} />
                    </div>
                    <div
                        className="Link"
                        onClick={() => {
                            // this logic on hold
                            // if (isParentInfoPresent) {
                            //     navigate("/StudentDashboard/Projects");
                            // } else {
                            //     setSnackbarOpen(true);
                            // }
                            navigate("/StudentDashboard/Projects");
                        }}
                    >
                        <img src={notepad} />
                    </div>
                    <div
                        className="Link"
                        onClick={() => navigate("/StudentDashboard/CourseList")}
                    >
                        <img src={hat} />
                    </div>
                    <div
                        className="Link"
                        onClick={() => {
                            // this logic on hold
                            // if (isParentInfoPresent) {
                            //     navigate("/StudentDashboard/Quiz");
                            // } else {
                            //     setSnackbarOpen(true);
                            // }
                            navigate("/StudentDashboard/Quiz");
                        }}
                    >
                        <img src={boxes} />
                    </div>
                    <div
                        className="Link"
                        onClick={() => {
                            // this logic on hold
                            // if (isParentInfoPresent) {
                            //     navigate("/StudentDashboard/Quiz");
                            // } else {
                            //     setSnackbarOpen(true);
                            // }
                            navigate("/StudentDashboard/Assessment");
                        }}
                    >
                        <img src={assessment} />
                    </div>
                    <div className="Link">
                        <ButtonGroup ref={anchorRef}>
                            <Box onClick={handleToggle}>
                                <img src={more} />
                            </Box>
                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                role={undefined}
                                transition
                                disablePortal
                            >
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{
                                            transformOrigin:
                                                placement === "bottom"
                                                    ? "center top"
                                                    : "center bottom",
                                        }}
                                    >
                                        <Paper
                                            sx={{
                                                backgroundColor: "transparent",
                                            }}
                                        >
                                            <ClickAwayListener
                                                onClickAway={handleClose}
                                            >
                                                <MenuList
                                                    id="split-button-menu"
                                                    sx={{
                                                        
                                                        width: "50px",
                                                        top: "20px",
                                                        zIndex: "1000",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        gap: "20px",
                                                    }}
                                                >
                                                    <MenuItem
                                                        sx={{
                                                            fontSize: "14px",
                                                        }}
                                                        key="prof"
                                                        onClick={() => {
                                                            setOpen(false);
                                                            navigate(
                                                                "/StudentDashboard/StudentProfile"
                                                            );
                                                        }}
                                                    >
                                                        <img src={user} style={{ width: "20px", height: "20px" }} />
                                                    </MenuItem>
                                                    <MenuItem
                                                        sx={{
                                                            fontSize: "14px",
                                                        }}
                                                        key="logoot"
                                                        onClick={() => {
                                                            setOpen(false);
                                                            logout();
                                                        }}
                                                    >
                                                        <img src={logOut} style={{ width: "20px", height: "20px" }} />
                                                    </MenuItem>
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SideBar;
